import React from 'react';
import '../styles/OurManagement.css';
import { PageHeader } from '../components';

const OurManagement: React.FC = () => {
  return (
    <div className="our-management">
      <PageHeader title="Our Management" />
      <div className="our-management-container">
        
        
        <div className="our-management-content">
          <section className="our-management-section">
            <h2>Leadership Excellence</h2>
            <p>
              WTIL is led by a seasoned leadership team with deep experience in engineering, project execution, operations, and chemical formulation. Our management combines technical expertise with strong industry insight, allowing us to deliver high-performance systems and maintain long-term partnerships with India's top industrial houses.
            </p>
            <p>
              With a strong commitment to quality, innovation, and compliance, the leadership at WTIL ensures that every solution we deliver is aligned with client expectations, national water standards, and global sustainability goals.
            </p>
          </section>
          
          <section className="our-management-section">
            <h2>Our Leadership Team</h2>
            <div className="leadership-grid">
              <div className="leader-item">
                <div className="leader-header">
                  <h3>Mr. P.P. Maheshwari</h3>
                  <h4>Managing Director</h4>
                </div>
                <div className="leader-message">
                  <h5>From the Desk of Our Managing Director</h5>
                  <blockquote>
                    "Since our inception, we have focused on solving real-world water challenges through innovation, quality, and integrity. It gives me immense pride to see WTIL grow from Rajasthan's first water treatment company into a trusted partner for industries across India. Our mission is to serve with purpose and continually raise the bar for excellence in water management."
                  </blockquote>
                </div>
              </div>
              
              <div className="leader-item">
                <div className="leader-header">
                  <h3>Mr. Prabhav Maheshwari</h3>
                  <h4>Director</h4>
                </div>
                <div className="leader-message">
                  <h5>Note from Director</h5>
                  <blockquote>
                    "At Wasser, we are driven by the vision to build sustainable and future-ready water solutions. I strongly believe in integrating technology, automation, and domain expertise to deliver value across every stage of the water treatment lifecycle. Our team is committed to not just meeting expectations, but exceeding them."
                  </blockquote>
                </div>
              </div>
            </div>
          </section>
          
          <section className="our-management-section">
            <h2>Mission & Vision</h2>
            <div className="mission-vision-grid">
              <div className="mission-item">
                <h3>Mission</h3>
                <p>
                  Our mission is to revolutionize water treatment by partnering with customers to deliver cutting-edge, reliable, and cost-effective solutions. We are committed to executing high-impact water treatment projects with unmatched expertise, ensuring safe, clean, and sustainable water for industries while driving operational efficiency and environmental responsibility.
                </p>
              </div>
              
              <div className="vision-item">
                <h3>Vision</h3>
                <p>
                  To be a leader in delivering innovative, cost-effective water and wastewater treatment solutions, driving efficient reuse and sustainability.
                </p>
              </div>
            </div>
          </section>
          
          <section className="our-management-section">
            <h2>Our Values</h2>
            <ul className="values-list">
              <li>Technical expertise in engineering and project execution</li>
              <li>Deep industry insight and market understanding</li>
              <li>Commitment to quality, innovation, and compliance</li>
              <li>Long-term partnerships with leading industrial houses</li>
              <li>Alignment with national water standards and sustainability goals</li>
              <li>Purpose-driven service with excellence in water management</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default OurManagement;
